export default __webpack_public_path__ + "static/SectionTwo_01_03-2a971f48755c9a090f0ba2642d2fc65e.webp";